import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';
import store from "@/store/store";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: store.getters.getTheme === 'dark',
        themes: {
            light: {
                primary: colors.grey.darken2,
                secondary: colors.grey.lighten5,
                accent: '#9e0d01',
                accentText: '#FFFFFF',
            },
            dark: {
                primary: colors.grey.lighten5,
                secondary: colors.grey.darken4,
                accent: '#9e0d01',
                accentText: '#FFFFFF',
            }
        }
    }
});
